import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';

export interface PermissionsState {
    createMultipleAppointments: boolean;
}

export function createInitialState(): PermissionsState {
    return {
        createMultipleAppointments: false
    };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'settings' })
export class PermissionsStore extends Store<PermissionsState> {
    constructor() {
        super(createInitialState());
    }
}
